import { defineStore } from 'pinia';

import { G } from '@/_common';

import { main_stores } from './stores';
import { user_stores } from '@/_stores';

export const useStore = defineStore('Diarc', {
    state: () => ({
        lang: 'az',
        currency: 'AZN',
        translations: {},
        sidebarStatus: false,
        dataTableParams: {
            page: 1,
            rows: G.rowsPerPage,
            mainFilters: {},
            filters: ''
        },
        token: "",
        api_version: Object.assign({}, user_stores.api_version),
        api: Object.assign(main_stores.api, user_stores.api),
        data: Object.assign({}, user_stores.data),
    }),

    getters: Object.assign({
        getLang: (state) => () => {
            return state.lang;
        },
        getCurrency: (state) => () => {
            return state.currency;
        },
        getTranslation: (state) => () => {
            return state.translations;
        },
    }, main_stores.getters, user_stores.getters),

    actions: Object.assign({
        setLang(lang) {
            if (lang === undefined || lang == ''){
                lang = 'az';
            }
            this.lang = lang;
        },
        setCurrency(currency) {
            if (currency === undefined || currency == ''){
                currency = 'AZN';
            }
            this.currency = currency;
        },
        setTranslations(tr) {
            if (tr !== undefined){
                this.translations = tr;
            }
        },

    }, main_stores.actions, user_stores.actions),
    // actions: ,
});